module.exports = __webpack_public_path__ + "static/media/social-media.d97e1fe9.png";